import { render, staticRenderFns } from "./InvoiceLinkItem.vue?vue&type=template&id=9a8e91da&scoped=true&"
import script from "./InvoiceLinkItem.vue?vue&type=script&lang=js&"
export * from "./InvoiceLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceLinkItem.vue?vue&type=style&index=0&id=9a8e91da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e91da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8e91da')) {
      api.createRecord('9a8e91da', component.options)
    } else {
      api.reload('9a8e91da', component.options)
    }
    module.hot.accept("./InvoiceLinkItem.vue?vue&type=template&id=9a8e91da&scoped=true&", function () {
      api.rerender('9a8e91da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShipmentsPage/InvoiceLinkItem.vue"
export default component.exports